// extracted by mini-css-extract-plugin
export var infoItem = "_rb-2";
export var title = "_rb-0";
export var value = "_rb-1";